import type { MessageKey } from "./en";

// Hindi strings: externalised from day one, filled in before the Hindi release (OPEN-Q27).
// Missing keys fall back to English.
export const hi: Partial<Record<MessageKey, string>> = {
  "login.title": "साइन इन करें",
  "login.phone": "मोबाइल नंबर",
  "login.send": "व्हाट्सऐप पर कोड भेजें",
  "nav.dashboard": "डैशबोर्ड",
  "nav.review": "समीक्षा कतार",
};
